module.exports = __webpack_public_path__ + "img/company_icon3.0e49aba3.png";